// extracted by mini-css-extract-plugin
export default {"bg-img":"App_bg-img__RlOKo","contenedor":"App_contenedor__euG1W"};